import { Fragment, useState } from 'react'
import { Button } from "../../components";
import { Dialog, Transition, DialogPanel, DialogTitle, TransitionChild } from '@headlessui/react';
import { show } from '../../slices/toastSlice';
import { selectAccessToken } from '../../slices/staffSlice';
import { useSelector, useDispatch } from "react-redux";
import { fetchRequests, accessFileRequest } from '../../Requests/getRequests';
import { useNavigate } from 'react-router-dom';
import { authStaff } from '../../utils/constants';

function Report({ isOpen, closeModal }) {

    const dispatch = useDispatch();
    const accessToken = useSelector(selectAccessToken);
    const navigate = useNavigate();

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [fetchingReport, setFetchingReport] = useState(false);
    const [reportLink, setReportLink] = useState("");
    const [success, setSuccess] = useState(false);

    const handleFetchTransactions = async () => {
        // check if user has selected a date range
        const from = document.getElementById('from').value;
        const to = document.getElementById('to').value
        if (!from || !to) {
            dispatch(show({
                type : "error",
                state : true,
                message : "Please select a date range to generate the report."
            }))
            return;
        }

        setFetchingReport(true);

        let url = `/reports/staff/get-payments-range`;
        let headers = authStaff(accessToken);

        let params = {
            fromDate : fromDate,
            toDate : toDate
        }

        let res = await fetchRequests(url, "GET", headers, params, {});
        setFetchingReport(false);
        if (res?.code === 401) {
            // clear local storage and redirect to login
            localStorage.clear();
            navigate("/login");
            dispatch(show({
                type: "error",
                state: true,
                message: "Your session has expired. Please login to continue."
            }));
            return;
        }

        if (res?.err) {
            dispatch(show({
                type: "error",
                state: true,
                message: res?.err
            }));
            return;
        }

        if(res?.message){
            dispatch(show({
                type : "success",
                state : true,
                message : `${res?.message}`
            }))
        } else {
            dispatch(show({
                type : "success",
                state : true,
                message : `Report generated successfully`
            }))

            setSuccess(true);
            setReportLink(res);
        }

    }

    const downloadReport = async() => {
        let url = `/reports/staff/getReportFile`;
        let headers = authStaff(accessToken)
        let params = {
            name : reportLink.split("/")[1]
        }

        let res = await accessFileRequest(url, headers, params);
        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : `${res?.err}`
            }))
            return;
        }

        const fileUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = fileUrl;
        const fileName = res.headers['content-disposition'].split('filename=')[1];
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    return (
        <>
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black/25" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                            <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                    Generate Payment Report
                                </DialogTitle>
                                <div className="mt-2">
                                    <p className="text-sm text-gray-500">
                                        Select the date range for the report you want to generate. The report will include all transactions within the specified date range.
                                    </p>

                                    <form className='mt-4'>
                                        <div className='mb-4'>
                                            <label htmlFor="from" className='form-label'>From:</label>
                                            <input 
                                                type="date" 
                                                name="from" 
                                                id="from" 
                                                className='form-input disabled:opacity-75 disabled:bg-gray-200 placeholder:text-gray-700 disabled:cursor-not-allowed' 
                                                min={"2024-06-01"}
                                                max={new Date().toISOString().split('T')[0]} 
                                                onChange={(e) => setFromDate(e.target.value)} 
                                                required 
                                            />
                                        </div>

                                        <div className='mb-4'>
                                            <label htmlFor="to" className='form-label'>To:</label>
                                            <input 
                                                type="date" 
                                                name="to" 
                                                id="to" 
                                                className='form-input disabled:opacity-75 disabled:bg-gray-200 placeholder:text-gray-700 disabled:cursor-not-allowed' 
                                                min={fromDate || "2024-06-01"} 
                                                max={new Date().toISOString().split('T')[0]} 
                                                onChange={(e) => setToDate(e.target.value)} 
                                                required
                                            />
                                        </div>

                                        <div className="inline-flex items-center justify-between space-x-4">
                                            <Button 
                                                btnText="Generate Report"
                                                btnType="button"
                                                btnClasses="form-button"
                                                btnFunction={handleFetchTransactions}
                                                processing={fetchingReport}
                                            />

                                            {success &&
                                            <Button 
                                                btnText="Download"
                                                btnType="button"
                                                btnClasses="cancel-button"
                                                btnFunction={downloadReport}
                                            />
                                            }
                                        </div>
                                    </form>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>

            </Dialog>
        </Transition>
        </>
    )
}

export default Report